import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { object, string } from "yup";

import { SocialMedialInputField } from "./SocialMediaInputField";
import { SocialMediaSummaryField } from "./SocialMediaSummaryField";
import { FieldType } from "../types";

export function SocialMediaField(
  field: components["schemas"]["SocialMediaCheckField"]
): FieldType<components["schemas"]["SocialMediaCheckField"]> {
  return {
    field,
    inputElement: <SocialMedialInputField key={field.name} field={field} />,
    summaryElement: () => (
      <SocialMediaSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value ?? {
      high_school_name: "",
      college_country: "",
      college_name: "",
      twitter_url: "",
      facebook_url: "",
      instagram_url: "",
      linkedin_url: "",
      tiktok_url: "",
      reddit_url: "",
    },
    schema: socialMediaFieldSchema,
  };
}

export const socialMediaFieldSchema = object().shape({
  high_school_name: string().required().label(t("High school name")),
});
